import gql from 'graphql-tag';
import { getContextTMC } from '@/utils/tmc';

const query = gql`
  query TmcTaxInclusive($tmc: String!) {
    tmcTaxInclusive(tmc: $tmc) {
      is_tax_inclusive
    }
  }
`;

export default function tmcTaxInclusive({ apollo }) {
  const tmc = getContextTMC();
  return apollo.query({
    query,
    variables: {
      tmc: tmc
    }
  });
}
